import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Container, Form, Button, Card, Image } from "react-bootstrap";
import logo from "../assets/ts_ads_logo.svg"; // Make sure this path is correct
import axios from "axios";
import ButtonLoader from "../components/ButtonLoader";
import { Helmet } from "react-helmet";

const Otp = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [loginError, setLoginError] = useState(false);
  const [loginErrorMessage, setLoginErrorMessage] = useState("");

  const location = useLocation();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (localStorage.getItem("playtoken") !== null) {
      navigate("/play/" + slug);
    }
  }, [navigate, localStorage.getItem("playtoken")]);

  const onSubmit = (data) => {
    setLoading(true);
    axios
      .post(process.env.REACT_APP_BASE_URL + "/api/play-login", {
        slug: slug,
        code: data.code,
      })
      .then(function (response) {
        setLoading(false);
        if (response.status === 200) {
          const success = response.data.success;
          if (success === 1) {
            const token = response.data.token;
            let roleDefault = "/otp/" + slug;

            const redirectPath = location.state?.from?.pathname || roleDefault;

            localStorage.setItem("playtoken", token);

            // dispatch(login(userData));
            // const redirectPath = localStorage.getItem("redirect_path");
            navigate(redirectPath, { replace: true });
          } else {
            setLoginErrorMessage(response.data.data);
            setLoginError(true); // Email is not registered
            navigate(`/otp/${slug}`, { replace: true });
            setTimeout(() => {
              setLoginErrorMessage("");
              setLoginError(false);
            }, 10000);
          }
        }
      })
      .catch(function (error) {
        setLoading(false);
        let errorMessage = "Unable to connect at the moment, please try again.";
        if (error.response.data.errors) {
          errorMessage = error.response.data.errors;
        }
        setLoginErrorMessage(errorMessage);
        setLoginError(true); // Email is not registered
        setTimeout(() => {
          setLoginErrorMessage("");
          setLoginError(false);
        }, 10000);
        navigate(`/otp/${slug}`);
      });
  };

  return (
    <Container className="d-flex justify-content-center align-items-center vh-100">
      <Helmet>
        <title>{`${process.env.REACT_APP_NAME} | Connect Screen`}</title>
      </Helmet>
      <Card style={{ width: "24rem" }}>
        <Card.Body>
          <div className="text-center mb-3">
            <Image src={logo} alt="Digital Signage" height={100} />
          </div>
          <h3 className="text-center mb-3 fs-6">Connect Screen</h3>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3">
              <Form.Label className="text-small">Passcode</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter passcode"
                {...register("code", { required: "Code is required" })}
                isInvalid={!!errors.password}
              />
              <Form.Control.Feedback type="invalid">
                {errors.code?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Button variant="primary" type="submit" className="w-100">
              {!loading ? `Submit` : <ButtonLoader />}
            </Button>
          </Form>
          {loginError === true && (
            <div className="alert alert-danger my-3" role="alert">
              {loginErrorMessage}
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default Otp;
